import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './index.css';
import App from './App';
import LegacyViewer from './containers/legacy';
import FormViewer from './containers/fillableform';
import ChoiceViewer from './containers/choicereview';
import FormReview from './containers/formreview';
import PageOrder from './containers/pageorder';
import AnnotationImport from './containers/annotationimport';
//import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';
import {
  TermsOfUse,
  TermsOfUseArchive,
  TermsOfUsePerm
} from './containers/termsofuse';
import Login from './containers/signin';
import DocumentsTable from './containers/documenttable';
import Externalviewer from './containers/externalviewer';
import { AuthProvider } from './containers/externalauthentication/authprovider';
import { PrivateRoute } from './containers/externalauthentication/externalprivateroute';
import { IntegrationViewer } from './containers/integration';
import queryString from 'query-string';
import Expired from './containers/expired';

export const isModernApi = () => {
  const parsed = queryString.parse(window.location.search);
  if (parsed.newchive) {
    return true;
  }
  return false;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <Router>
      <Routes>
        <Route path="/legacy/:client/:superid" element={<LegacyViewer />} />
        <Route path="/current/:superid" element={<App />} />
        <Route
          path="/choicereview/:client/:superid/:formid"
          element={<ChoiceViewer />}
        />
        <Route path="/formreview/:client/:formpath" element={<FormReview />} />
        <Route
          path="/choiceforms/:client/:superid/:currentStudent?"
          element={<FormViewer />}
        />

        <Route
          path="/cumulativefolder/:client/:superid/:tenant/:stage"
          element={<IntegrationViewer />}
        />
        <Route
          path="/integration/:client/:superid/:tenant/:stage"
          element={<IntegrationViewer />}
        />
        <Route path="/pageorder/:client/:superid" element={<PageOrder />} />
        <Route
          path="/importannotations/:client"
          element={<AnnotationImport />}
        />
        <Route path="/termsofuse" element={<TermsOfUse />} />
        <Route path="/termsofuseperm" element={<TermsOfUsePerm />} />
        <Route
          path="/termsofusearchive/:districtName"
          element={<TermsOfUseArchive />}
        />

        <Route
          path="/external"
          element={<PrivateRoute component={DocumentsTable} />}
        />
        <Route path="/external/signin" element={<Login />} />
        <Route
          path="/external/viewer/:superid"
          element={<PrivateRoute component={Externalviewer} />}
        />
        <Route path="/expired" element={<Expired />} />
      </Routes>
    </Router>
  </AuthProvider>
);
console.log('calling unregister');
unregister();
